// extracted by mini-css-extract-plugin
export var caretAnchor = "_vn-0";
export var dropdownContent = "_vn-1";